module.exports = __webpack_public_path__ + "987b84570ea69ee660455b8d5e91f5f1.woff2";